export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9352.e4e8cd57.jpg";